import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getSetupProposals } from "../../api/setupApi";
import { getActiveTenant } from "../../helpers/tenantHelpers";
import "./SetupCard.css";

/* Backstop entry point: appears on the dashboard only when the tenant has
   inferred-but-unconfirmed setup. This catches new tenants who never navigate
   to the screen where a gap bites, and gaps (like identity) that have no
   natural home. Dismissable per-tenant for the session; the Setup screen and
   the point-of-bite cards remain the durable paths. */
export default function FinishSetupBanner() {
  const navigate = useNavigate();
  const [count, setCount] = useState(0);
  const tenant = getActiveTenant();
  const dismissKey = `setup_banner_dismissed_${tenant?.id || "x"}`;
  const [dismissed, setDismissed] = useState(() => {
    try { return sessionStorage.getItem(dismissKey) === "1"; } catch { return false; }
  });

  useEffect(() => {
    let live = true;
    getSetupProposals()
      .then((d) => { if (live) setCount(d?.counts?.open || 0); })
      .catch(() => { if (live) setCount(0); });
    return () => { live = false; };
  }, []);

  if (dismissed || count <= 0) return null;

  return (
    <div
      className="setup-banner"
      role="button"
      tabIndex={0}
      onClick={() => navigate("/setup")}
      onKeyDown={(e) => e.key === "Enter" && navigate("/setup")}
    >
      <span className="setup-banner__dot" />
      <div className="setup-banner__text">
        <div className="setup-banner__title">Finish setting up your account</div>
        <div className="setup-banner__sub">
          We inferred {count} thing{count === 1 ? "" : "s"} from your data — review and confirm.
        </div>
      </div>
      <span className="setup-banner__chev">›</span>
      <button
        className="setup-banner__x"
        aria-label="Dismiss"
        onClick={(e) => {
          e.stopPropagation();
          try { sessionStorage.setItem(dismissKey, "1"); } catch { /* ignore */ }
          setDismissed(true);
        }}
      >
        ×
      </button>
    </div>
  );
}
